<template>
  <header class="header">
    <div class="header-search">
      <h1 aria-label="Fair Shopping" class="h1"><a :href="baseUrl"><img class="logo" src="./../assets/logo.svg" role="presentation" /></a></h1>
      <section role="search" class="search flex flex--js">
        <input class="search__input" type="search" placeholder="Search fair products" v-model="query">
      </section>
    </div>
    <nav role="navigation" aria-label="Explore Topics" class="topics">
      <ul role="menubar" class="flex flex--ac">
        <li role="menuitem" class="topic"><button class="button" @click="search('Bags')">Bags</button></li>
        <li role="menuitem" class="topic"><button class="button" @click="search('Jeans')">Jeans</button></li>
        <li role="menuitem" class="topic"><button class="button" @click="search('Dresses')">Dresses</button></li>
        <li role="menuitem" class="topic"><button class="button" @click="search('Sneakers')">Sneakers</button></li>
        <li role="menuitem" class="topic"><button class="button" @click="search('Jewelry')">Jewelry</button></li>
        <li role="menuitem" class="topic"><button class="button" @click="search('T-Shirts')">T-Shirts</button></li>
        <li role="menuitem" class="topic"><button class="button" @click="search('Recycled')">Recycled</button></li>
        <li role="menuitem" class="topic"><button class="button" @click="search('Vintage')">Vintage</button></li>
        <li role="menuitem" class="topic"><button class="button" @click="search('Vegan')">Vegan</button></li>
      </ul>
    </nav>
    <a class="branding" href="https://zoovu.com/?utm_source=&fairshopping&utm_medium=fairshopping&utm_campaign=fairshopping/" target="_blank" rel="noopener noreferrer">
      <img src="../assets/powered-by-zoovu.png" alt="Powered by Zoovu" class="branding__logo">
    </a>
  </header>

</template>

<script>
export default {
	name: 'Toolbar',
	data() {
		return {
			query: '',
			baseUrl: '/'
		};
	},
	methods: {
		search(query) {
			this.query = query;
			window.SS360.showResults(query);
		}
	},
	beforeMount() {
		this.isDev = window.location.pathname.includes('dev');
		this.baseUrl = this.isDev ? '/dev' : '/';
	}
};
</script>

<style lang="scss">
.header {
  z-index: 99999;
  flex-direction: column;
  max-width: 1100px;
  margin: 0 auto;
}

.header-search {
  display: flex;
  width: 100%;
  align-items: flex-end;

  .search {
    width: auto;
    margin: 0 auto;
  }

  .h1 a {
    display: flex;
  }
}

.branding {
  display: block;
  text-align: right;
  width: 100%;
  margin-left: auto;

  &__logo {
    max-height: 20px;
    padding: 0 1em;
  }
}

.topics {
  position: static;

  ul {
    justify-content: center;
  }
}
</style>